// extracted by mini-css-extract-plugin
export var defaultWrapper = "_j0-3";
export var downloadButton = "_j0-4";
export var fileContainer = "_j0-9 _j0-7";
export var fileContainerBase = "_j0-7";
export var fileContainerFixedHeight = "_j0-8 _j0-7";
export var fileInfo = "_j0-5";
export var fileInfoWidthRestricted = "_j0-6";
export var fileType = "_j0-1";
export var fileTypeName = "_j0-2";
export var image = "_j0-0";
export var link = "_j0-b";
export var overflowEllipsis = "_j0-a";